import { Component, OnInit } from '@angular/core';

import {
  AuthenticationService, 
  ContactApiService,
} from '../data-services/index';

import {
  IContact, IUser, IHelp, HelpApiService
} from '@ebb-v2/ebb-integration';


@Component({
    selector: 'ebb-portal-resources',
    templateUrl: './resources.component.html',
    standalone: false
})
export class ResourcesComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public listHelp: IHelp[] = [];

  public textContractorResources: string;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly apiContact: ContactApiService,
    private apiHelp: HelpApiService
  ) { }


  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getContact(this.currentUser.id);
    this.loadHelpText();
  }

  private getContact(currentId: string): void {
    this.apiContact
      .getContact(currentId)
      .subscribe(
        data => {
         this.currentContact = data;
        },
        error => console.warn(`ERROR: Training.getContact() - ${error}`)
      )
  }

  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = [...data];
          const indexContractorResources = this.listHelp.findIndex(i => i.name.toLowerCase() === 'contractorresources');
          if (indexContractorResources >= 0)
            this.textContractorResources = this.listHelp[indexContractorResources].answer;
        },
        error => console.log(error)
      );
  }
}
